"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bulkCreateContractsApiResponseSchema = exports.bulkCreateContractsPreviewApiResponseSchema = exports.bulkCreateContractsPreviewItemSchema = void 0;
const zod_1 = require("zod");
exports.bulkCreateContractsPreviewItemSchema = zod_1.z.object({
    officeId: zod_1.z.string(),
    officeName: zod_1.z.string(),
    doctorAttendingId: zod_1.z.string(),
    doctorAttendingName: zod_1.z.string(),
    doctorSubstituteId: zod_1.z.string(),
    doctorSubstituteName: zod_1.z.string(),
    retrocessionRate: zod_1.z.number(),
    slotsCount: zod_1.z.number(),
});
exports.bulkCreateContractsPreviewApiResponseSchema = zod_1.z.object({
    data: zod_1.z.array(exports.bulkCreateContractsPreviewItemSchema),
});
exports.bulkCreateContractsApiResponseSchema = zod_1.z.object({
    created: zod_1.z.number(),
    skipped: zod_1.z.number(),
    failed: zod_1.z.number(),
});
